module.exports = __webpack_public_path__ + "img/asset_delete_white.f843053d.svg";